var map = {
	"./add_to_cart.svg": "3c2f",
	"./clients.svg": "90ee",
	"./empty.svg": "e0c8",
	"./forgot.svg": "579e",
	"./login.svg": "d625",
	"./lost.svg": "888a",
	"./mail_sent.svg": "e5e1",
	"./map_dark.svg": "670f",
	"./messages.svg": "6f6c",
	"./no_data.svg": "3dbf",
	"./password_reset.svg": "77e1",
	"./pricing_salon.svg": "030a",
	"./pricing_team.svg": "80f4",
	"./pricing_woman.svg": "6690",
	"./reset_password_sent.svg": "2d5b",
	"./sales_report.svg": "9e39",
	"./schedule.svg": "4876",
	"./setup.svg": "0472",
	"./success.svg": "0bf4",
	"./success2.svg": "92ed",
	"./thank_you.svg": "d3d6",
	"./users.svg": "4e3e",
	"./wall_post.svg": "1b92"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7c6e";